import { Button, Stack } from '@mui/material'
import { FC, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useScreenSize } from '../../hooks/useScreenSize'

export const NavTabs: FC<{
    tabs: Record<string, string>
    badges?: Record<string, boolean | undefined>
}> = ({ tabs, badges }) => {
    const { isMobile } = useScreenSize()

    const { currentTab, changeTab, tabsList } = useNavTabs(tabs)

    useEffect(() => {
        if (!currentTab || !tabsList.includes(currentTab)) {
            changeTab(tabsList[0])
        }
    }, [currentTab])

    return (
        <Stack direction="row" spacing={1} mb="-2px" px={1} zIndex={0}>
            {tabsList.map((item) => (
                <Button
                    badge={badges?.[item]}
                    key={item}
                    tab
                    size={isMobile ? 'medium' : 'large'}
                    onClick={() => {
                        changeTab(item)
                    }}
                    fullWidth
                    selected={item === currentTab}
                >
                    {item}
                </Button>
            ))}
        </Stack>
    )
}

export const useNavTabs = (tabs?: Record<string, string>) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const tabsList = Object.values(tabs || {})
    const currentTab = searchParams.get('tab') || ''

    const changeTab = (value) => {
        searchParams.set('tab', value)
        setSearchParams(searchParams, { replace: true })
    }

    return {
        currentTab,
        changeTab,
        tabsList,
    }
}
